import React from "react";
import { HiOutlineBookOpen } from "react-icons/hi";

function RegulatorUserManual() {
  return (
    <main className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-4xl p-8">
        <div className="rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
          <div className="mb-4 flex items-center gap-3">
            <div className="rounded-lg bg-blue-100 p-2">
              <HiOutlineBookOpen size={24} className="text-blue-600" />
            </div>
            <h1 className="font-ui text-3xl font-bold text-gray-800">PolicyPlan User Manual</h1>
          </div>
          <p className="font-ui text-gray-600">
            The PolicyPlan user manual is being prepared and will be available here soon.
          </p>
        </div>
      </div>
    </main>
  );
}

export default RegulatorUserManual;
